module.exports = __webpack_public_path__ + "img/hardware2.bd84aa1c.png";